// Gestion du changement de background au survol des megamenus
document.addEventListener('DOMContentLoaded', function() {
  const headerTop = document.querySelector('.site-header__element--top');
  const megamenuItems = document.querySelectorAll('.site-nav--is-megamenu');
  
  if (!headerTop || megamenuItems.length === 0) return;
  
  let isHovering = false;
  let hoverTimeout;
  
  // Fonction pour ajouter la classe de survol
  function addMegamenuHover() {
    if (isHovering) return;
    isHovering = true;
    headerTop.classList.add('megamenu-hover');
  }
  
  // Fonction pour retirer la classe de survol avec délai
  function removeMegamenuHover() {
    isHovering = false;
    // Petit délai pour éviter le clignotement lors du passage de la souris
    clearTimeout(hoverTimeout);
    hoverTimeout = setTimeout(() => {
      if (!isHovering) {
        headerTop.classList.remove('megamenu-hover');
      }
    }, 100);
  }
  
  // Ajouter les événements de survol à chaque élément megamenu
  megamenuItems.forEach(item => {
    item.addEventListener('mouseenter', addMegamenuHover);
    item.addEventListener('mouseleave', removeMegamenuHover);
    
    // Gérer aussi le survol du dropdown megamenu
    const dropdown = item.querySelector('.site-nav__dropdown');
    if (dropdown) {
      dropdown.addEventListener('mouseenter', addMegamenuHover);
      dropdown.addEventListener('mouseleave', removeMegamenuHover);
    }
  });
  
  // Gérer aussi le survol du header lui-même
  headerTop.addEventListener('mouseenter', addMegamenuHover);
  headerTop.addEventListener('mouseleave', removeMegamenuHover);
  
  // Nettoyer le timeout lors de la destruction de la page
  window.addEventListener('beforeunload', () => {
    clearTimeout(hoverTimeout);
  });
}); 